import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import Header from '../Header';
import './index.css';

const LeadsList = () => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    const id = localStorage.getItem('userId');
    const fetchLeads = async () => {
      try {
        const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/leadby/${id}`, {
          method: 'GET',
        });

        if (!response.ok) {
          throw new Error('Failed to fetch leads');
        }

        const data = await response.json();
        
        setLeads(data.leads || []);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchLeads();
  }, []);

  const handleAction = (action, id) => {
    if (action === 'edit') {
      navigate(`/edit-lead/${id}`);
    } else if (action === 'delete') {
      const confirmDelete = window.confirm('Are you sure you want to delete this lead?');
      if (confirmDelete) {
        fetch(`https://apiaksharaconnect.aksharafinalytics.in/delete_lead/${id}`, {
          method: 'DELETE',
        })
          .then((response) => {
            if (response.ok) {
              setLeads((prevLeads) => prevLeads.filter((lead) => lead.id !== id));
              alert('Lead deleted successfully');
            } else {
              return response.json().then((errorData) => {
                throw new Error(errorData.message || 'Failed to delete lead');
              });
            }
          })
          .catch((error) => {
            alert(`Error deleting lead: ${error.message}`);
          });
      }
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  if (loading) {
    return (
      <div className="text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger">
        <strong>Error:</strong> {error}
      </div>
    );
  }

  return (
    <>
      <Header />
      <div className="shadow mx-1 px-3 bg-light rounded-3">
        <div className="d-flex align-items-center justify-content-between p-3 mt-3">
          <h4 className="mb-0">Lead Management</h4>
          <button className="btn btn-primary" onClick={() => navigate('/Lead')}>
            Add Lead
          </button>
        </div>

        {successMessage && (
          <div className="alert alert-success" role="alert">
            {successMessage}
          </div>
        )}

        <div className="card">
          <div className="card-header">Lead List</div>
          <div className="card-body">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>S.no</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>WhatsApp</th>
                  <th>Address</th>
                  <th>Source</th>
                  <th>Date</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(leads) && leads.length > 0 ? (
                  leads.map((lead, index) => (
                    <tr key={lead.id}>
                      <td>{index + 1}</td>
                      <td>{lead.name || 'N/A'}</td>
                      <td>{lead.email || 'N/A'}</td>
                      <td>{lead.phone || 'N/A'}</td>
                      <td>{lead.whatsapp || 'N/A'}</td>
                      <td>{lead.address || 'N/A'}</td>
                      <td>{lead.source || 'N/A'}</td>
                      <td>{formatDate(lead.lead_date)}</td>
                      <td
                        style={{
                          color:
                            lead.status === 'Closed'
                              ? 'green'
                              : lead.status === 'In Progress'
                              ? 'orange'
                              : 'blue',
                        }}
                      >
                        {lead.status || 'Unknown'}
                      </td>
                      <td>
                        <button
                          className="btn btn-warning ms-2 p-1 m-1"
                          onClick={() => handleAction('edit', lead.id)}
                          title="Edit"
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </button>
                        <button
                          className="btn btn-danger ms-2 p-1 m-1"
                          onClick={() => handleAction('delete', lead.id)}
                          title="Delete"
                        >
                          <FontAwesomeIcon icon={faTrashAlt} />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10">No leads available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeadsList;
